module.exports = __webpack_public_path__ + "img/body-1.910edbc4.png";